<template>
    <div class="breadcrumbs-wrapper">
        <ul class="breadcrumbs">
            <slot :items="pathRoutes" :current="currentRoute">
                <router-link v-for="item in pathRoutes" :key="item.route" class="breadcrumb-item capitalize" :to="{name: item.route}">{{item.title}}</router-link>
                <li class="breadcrumb-item capitalize current">{{currentRoute}}</li>
            </slot>
        </ul>
        <slot name="after"></slot>
    </div>
</template>
<script setup>
    import { computed } from 'vue';
    import { cleanString } from '@/utils/filters.js';

    import { useRoute, useRouter } from 'vue-router';

    const $route = useRoute();
    const $router = useRouter();

    const props = defineProps({
        path: Array
    });

    let pathRoutes = computed(() => {
        const routes = [];
        props.path?.forEach(path => {
            let routeName = path?.key || path;
            try {
                const resolved = $router.resolve({name: routeName});
                if(!resolved) return;

                routes.push({route: routeName, title: getRouteTitle(resolved)});
            } catch (error) {
                
            }
            
        });

        return routes;
    });

    let currentRoute = computed(() => {
        return getRouteTitle($route);
    });

    function getRouteTitle(route) {
        let routeName = route.name;

        if(routeName === 'form'){
            routeName = route.params.name;
        }

        return route.meta.title || cleanString(routeName);
    }
</script>
<style lang="scss" scoped>
    .breadcrumbs{
        display: inline-flex;
        
        line-height: 1.5;

        .breadcrumb-item, :slotted(.breadcrumb-item){
            // padding: 0.5rem 0;
            align-items: center;
            border-radius: var(--border-radius);
            transition-property: border-color, background, color;
            transition-duration: 0.2s;
            max-width: 40ch;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            display: block;

            &[href]:hover, [href]:hover{
                text-decoration: underline;
            }

            &:not(:first-child){
                &::before{
                    background-image: url(/images/caret_right.svg);
                    background-repeat: no-repeat;
                    background-position: center;
                    display: inline-block;
                    width: 2rem;
                    height: 0.8rem;
                    content: "";
                    flex: none;
                    // margin-left: 0.5rem;
                    // margin-right: 0.5rem;
                    // font-size: 1.7em;
                    // content: "\203A";
                    // line-height: 0.5;
                    // display: inline-block;
                    // height: 0.7em;
                    // vertical-align: text-bottom;
                }
            }

            &:last-child, &.current{
                color: var(--primary-color);
            }

            // &:last-child::after{
            //     display: none;
            // }
        }

        .hint-link{
            align-self: center;
            line-height: 1;
        }
    }

    @media screen and (max-width:768px) {
        .breadcrumbs{
            overflow: auto;

            .breadcrumb-item, :slotted(.breadcrumb-item){
                overflow: initial;
            }
        }
    }
</style>